// extracted by mini-css-extract-plugin
export default {"dishImageModal__image":"dishImageModal_dishImageModal__image__Q2+Xj","dishImageModal__imageAction":"dishImageModal_dishImageModal__imageAction__WJDFH"};